import script from "./TinyEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./TinyEditor.vue?vue&type=script&setup=true&lang=ts"

import "./TinyEditor.vue?vue&type=style&index=0&id=efc24a18&lang=css"

const __exports__ = script;

export default __exports__